module.exports = __webpack_public_path__ + "img/photo05_pc.4e7430ff.jpg";